import * as CONSTANTS from '../../constants';

/**
 * Toggle minimize navbar
 *
 * @param commit
 */
export const toggleMinimizeNav = ({ commit }) => {
    commit(CONSTANTS.NAV_MINIMIZE_TOGGLE);
};

/**
 * Set minimized navbar.
 *
 * @param commit
 * @param payload
 */
export const setMinimizedNav = ({ commit }, payload) => {
    commit(CONSTANTS.NAV_MINIMIZE_SET, payload);
};

/**
 * Toggle the top navbar menu.
 * Update selected language.
 *
 * @param commit
 * @param payload
 */
export const toggleNavMenu = ({ commit }, payload) => {
    commit(CONSTANTS.NAV_MENU_TOGGLE, payload);
};

/**
 * Update the selected language.
 *
 * @param commit
 * @param payload
 */
export const updateLanguage = ({ commit }, payload) => {
    commit(CONSTANTS.LANGUAGE_SELECT, payload);
};

/**
 * Set the valid languages from the JSON files in i18n.
 *
 * @param commit
 * @param payload
 */
export const setLanguages = ({ commit }, payload) => {
    commit(CONSTANTS.LANGUAGE_SET, payload);
};



// WEBPACK FOOTER //
// ./src/store/modules/nav/actions.js